import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { useMyRegistrations } from "../../hooks/useMyRegistrations";
import MyRegistrationCard from "../MyRegistrationCard/MyRegistrationCard";
import { MyRegistrationItem } from "../../api/getMyRegistrations/types";
import { Link } from "react-router-dom";

function RegistrationList({
  items,
  emptyMessage,
}: {
  items: MyRegistrationItem[];
  emptyMessage: React.ReactNode;
}) {
  if (items.length === 0) {
    return (
      <div className="py-16 text-center">
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {emptyMessage}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {items.map((r) => (
        <MyRegistrationCard key={r.sessionUuid} registration={r} />
      ))}
    </div>
  );
}

const MyRegistrationsPage: React.FC = () => {
  const { upcoming, past, loading, error } = useMyRegistrations();

  return (
    <MainPageWrapper title="My Registrations" loading={loading}>
      {error && (
        <div className="py-16 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">{error}</p>
        </div>
      )}

      {!error && !loading && (
        <Tabs defaultValue="upcoming">
          <TabsList>
            <TabsTrigger value="upcoming">
              Upcoming{upcoming.length > 0 ? ` (${upcoming.length})` : ""}
            </TabsTrigger>
            <TabsTrigger value="past">
              Past{past.length > 0 ? ` (${past.length})` : ""}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="upcoming">
            <RegistrationList
              items={upcoming}
              emptyMessage={
                <>
                  No upcoming registrations.{" "}
                  <Link
                    to="/event-registration/events"
                    className="text-gray-900 dark:text-white underline"
                  >
                    Browse events
                  </Link>
                </>
              }
            />
          </TabsContent>

          <TabsContent value="past">
            <RegistrationList
              items={past}
              emptyMessage="No past registrations."
            />
          </TabsContent>
        </Tabs>
      )}
    </MainPageWrapper>
  );
};

export default MyRegistrationsPage;
